import React from 'react'
import PropTypes from 'prop-types'

import Loading from '../components/loading'
import request from '../util/request'
import StateComparisonChart from '../components/state-comparison-chart'
import StateComparisonSelect from '../components/state-comparison-select'
import statesToArray from '../util/states-to-array'

class StateCompare extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
      compareTo: '',
    }
    this.onCompareToChange = this.onCompareToChange.bind(this)
  }

  componentWillMount() {
    const { data } = this.state
    /* istanbul ignore next */
    if (!data.dimensions) {
      this.loadJSON('dimensions')
    }
  }

  /* istanbul ignore next */
  componentWillReceiveProps() {
    const { data } = this.state
    if (!data.dimensions) {
      this.loadJSON('dimensions')
    }
  }

  onCompareToChange(state) {
    this.setState({ compareTo: state })
  }

  async loadJSON(name) {
    const newData = await request(`/data/${name}.json`)
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [name]: newData,
      },
    }))
  }

  sortByDimension(dimension) {
    const { data } = this.state
    const states = statesToArray(data.dimensions)
    return states.sort(
      (a, b) => parseFloat(a[1][dimension]) - parseFloat(b[1][dimension]),
    )
  }

  comparisonDataForDimension(dimension, sortedData) {
    const { state } = this.props
    const { compareTo, data } = this.state
    const sorted = sortedData[dimension]
    return {
      min: parseFloat(sorted[0][1][dimension]),
      max: parseFloat(sorted[sorted.length - 1][1][dimension]),
      states: {
        [state]: parseFloat(data.dimensions[state][1][dimension]),
        [compareTo]: (compareTo === '') ?
          0 : parseFloat(data.dimensions[compareTo][1][dimension]),
      },
    }
  }

  comparisonData() {
    const sortedData = {
      OVERALL: this.sortByDimension('OVERALL'),
      USE: this.sortByDimension('USE'),
      ACCESS: this.sortByDimension('ACCESS'),
      LIVES: this.sortByDimension('LIVES'),
      DISPARITY: this.sortByDimension('DISPARITY'),
      QUALITY: this.sortByDimension('QUALITY'),
    }
    return {
      'Overall Rank': this.comparisonDataForDimension(
        'OVERALL', sortedData,
      ),
      'Access and Affordability': this.comparisonDataForDimension(
        'ACCESS', sortedData,
      ),
      'Prevention and Treatment': this.comparisonDataForDimension(
        'QUALITY', sortedData,
      ),
      'Avoidable Hospital Use and Cost': this.comparisonDataForDimension(
        'USE', sortedData,
      ),
      'Healthy Lives': this.comparisonDataForDimension(
        'LIVES', sortedData,
      ),
      Disparity: this.comparisonDataForDimension(
        'DISPARITY', sortedData,
      ),
    }
  }

  render() {
    const { compareTo, data } = this.state
    if (!data.dimensions) {
      return (<Loading message={'Loading data...'} />)
    }
    return (
      <div>
        <StateComparisonSelect
          changeHandler={this.onCompareToChange}
          state={this.props.state}
          selected={compareTo}
        />
        <StateComparisonChart
          data={this.comparisonData()}
        />
      </div>
    )
  }
}

StateCompare.propTypes = {
  state: PropTypes.string.isRequired,
}

export default StateCompare



// WEBPACK FOOTER //
// ./src/components/Visualizations/containers/state-compare.jsx